import React, { useEffect, useState } from "react";
import {
  Switch,
  BrowserRouter as Router,
  Link,
  Route,
  Redirect,
  NavLink,
} from "react-router-dom";
import { useHistory } from "react-router";
import "./App.css";
import { Login } from "./user/Login";
import { getListConfig, getMainConfig, getViewSettings } from "./config";
import { DMInit, Main } from "digimaker-ui";
import util from "digimaker-ui/util";
import { FetchWithAuth } from "digimaker-ui/util";
import ErrorBoundary from "./ErrorBoundary";
import StudentView from "./student/View";
import StudentCreate from "./student/Create";
import StudentEdit from "./student/Edit";
import FinanceList from "./finance/List";
import { Edit as ContentEdit } from "digimaker-ui/actions";
import { Layout, Menu } from "antd";
import Sider from "antd/lib/layout/Sider";
import { SettingOutlined, UserOutlined } from "@ant-design/icons";
import SubMenu from "antd/lib/menu/SubMenu";
import { Content, Footer } from "antd/lib/layout/layout";
import "./Init";
import Logo from "./images/icd-logo.png";
import SubjectList from "./subject/List";
import SubjectView from "./subject/View";
import ResultList from "./subject/ResultList";
import FinanceView from "./finance/View";
import AddFinanceRecord from "./finance/AddRecord";
import SubjectResultView from "./subject/SubjectResultView";
import EditFinanceRecord from "./finance/EditRecord";
import ImportStudents from "./import/ImportStudents";
import ImportFinanceRecords from "./import/ImportFinanceRecords";
import StudentList from "./student/List";
import { Logout } from "./user/Logout";
import { EditContent } from "./content/EditContent";

const App: React.FC = () => {
  // util.setConfig(Config);
  // util.setCookieKey("dm_eui"); //todo: use .env?
  const errorMessage = "No access to view";

  const [currentUser, setCurrentUser] = useState<any>(null);
  useEffect(() => {
    FetchWithAuth("user/current/admin").then((data) => {
      if (data.error === false) {
        setCurrentUser(data.data);
      }
    });
  }, []);

  const history = useHistory();
  const navigate = (url: string) => {
    console.log(history);
    history.push(url);
  };

  return (
    <ErrorBoundary>
      <Router>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/logout" render={() => <Logout />} exact={true} />
          {/* <Route
              path="/tinymce/select/:data"
              exact
              render={(route) => <Select data={route.match.params.data} />}
            /> */}
          <Route>
            <div className="App">
              <DMInit
                viewSettings={getViewSettings}
                dateTime={{ format: "YYYY-MM-DD HH:mm" }}
              >
                {currentUser && (
                  <Layout style={{ minHeight: "100vh" }} hasSider={true}>
                    <Sider theme="light">
                      {currentUser && (
                        <Route exact path="/">
                          <Redirect
                            exact
                            to={
                              currentUser.roles &&
                              currentUser.roles.includes("admin")
                                ? "/student/list"
                                : "/subject/result/list"
                            }
                          />
                        </Route>
                      )}
                      <Menu
                        defaultSelectedKeys={["student", "10"]}
                        defaultOpenKeys={["student"]}
                        mode="inline"
                      >
                        <div>
                          <Link to="/student/list">
                            <div className="logo">
                              <img src={Logo} />
                            </div>
                          </Link>
                        </div>
                        <SubMenu
                          key="student"
                          icon={<UserOutlined />}
                          title="Students"
                        >
                          {currentUser.roles &&
                            currentUser.roles.includes("admin") && (
                              <Menu.Item key="10">
                                <NavLink to="/student/list">Students</NavLink>
                              </Menu.Item>
                            )}
                          {currentUser.roles &&
                            currentUser.roles.includes("admin") && (
                              <Menu.Item key="11">
                                <NavLink to="/finance/list">Fees</NavLink>
                              </Menu.Item>
                            )}
                          <Menu.Item key="20">
                            <NavLink to="/subject/result/list">
                              Subject results
                            </NavLink>
                          </Menu.Item>
                        </SubMenu>

                        {currentUser.roles &&
                          currentUser.roles.includes("admin") && (
                            <SubMenu
                              key="setup"
                              icon={<SettingOutlined />}
                              title="System"
                            >
                              <Menu.Item key="30">
                                <NavLink to="/main/468">Courses</NavLink>
                              </Menu.Item>
                              <Menu.Item key="31">
                                <NavLink to="/main/469">Subjects</NavLink>
                              </Menu.Item>
                              <Menu.Item key="35">
                                <NavLink to="/main/480">Agencies</NavLink>
                              </Menu.Item>
                              <Menu.Item key="33">
                                <NavLink to="/main/477">Teachers</NavLink>
                              </Menu.Item>
                              <Menu.Item key="32">
                                <NavLink to="/main/4">Administrators</NavLink>
                              </Menu.Item>
                              <Menu.Item key="34">
                                <NavLink to="/main/7">Roles</NavLink>
                              </Menu.Item>
                            </SubMenu>
                          )}
                      </Menu>

                      <Footer style={{ padding: "10px", marginBottom: "0px" }}>
                        <div>
                          {currentUser.name} &nbsp;&nbsp;
                          <Link to="/logout" title="Log out">
                            <i className="fas fa-sign-out-alt"></i>
                          </Link>
                        </div>
                      </Footer>
                    </Sider>
                    <Layout className="site-layout">
                      <Content
                        style={{ margin: "0 16px", background: "white" }}
                      >
                        <div
                          style={{
                            margin: "0px 20px",
                            paddingTop: "10px",
                            paddingBottom: "80px",
                            minHeight: "100vh",
                            position: "relative",
                          }}
                        >
                          <Route path="/student/list" component={StudentList} />
                          <Route
                            path="/student/create"
                            component={StudentCreate}
                          />
                          <Route
                            path="/student/edit/:id"
                            render={(props) => (
                              <StudentEdit
                                id={parseInt(props.match.params.id)}
                                history={props.history}
                              />
                            )}
                          />
                          <Route
                            path="/edit/:contenttype/:id"
                            render={(props) => (
                              <ContentEdit
                                contenttype={props.match.params.contenttype}
                                id={parseInt(props.match.params.id)}
                                afterAction={(type: number) => {
                                  const location = window.location;
                                  const searchParams = new URLSearchParams(
                                    location.search,
                                  );

                                  const from = searchParams.get("from");
                                  if (from) {
                                    props.history.push(from);
                                  } else {
                                    props.history.push("/");
                                  }
                                  // navigate("/");
                                }}
                              />
                            )}
                          />
                          <Route
                            path="/student/view/:id"
                            render={(props) => (
                              <StudentView
                                id={parseInt(props.match.params.id)}
                              />
                            )}
                          />
                          <Route path="/finance/list" component={FinanceList} />
                          <Route
                            path="/finance/records/:id/add"
                            render={(props) => (
                              <AddFinanceRecord
                                id={parseInt(props.match.params.id)}
                                route={props}
                              />
                            )}
                            exact={true}
                          />
                          <Route
                            path="/finance/records/edit/:id"
                            render={(props) => (
                              <EditFinanceRecord
                                id={parseInt(props.match.params.id)}
                                route={props}
                              />
                            )}
                            exact={true}
                          />
                          <Route
                            path="/finance/records/:id"
                            render={(props) => (
                              <FinanceView
                                id={parseInt(props.match.params.id)}
                              />
                            )}
                            exact={true}
                          />
                          <Route path="/subject/list" component={SubjectList} />
                          <Route
                            path="/subject/view/:id"
                            render={(props) => (
                              <SubjectView id={props.match.params.id} />
                            )}
                          />
                          <Route
                            path="/subject/result/list"
                            component={ResultList}
                          />
                          <Route
                            path="/subject/result/view/:id"
                            exact={true}
                            render={(props) => (
                              <SubjectResultView id={props.match.params.id} />
                            )}
                          />

                          <Route
                            path="/import/students"
                            component={ImportStudents}
                          />
                          <Route
                            path="/import/finance-records"
                            component={ImportFinanceRecords}
                          />
                          <Route
                            path="/main/:id"
                            exact={true}
                            render={(route) => (
                              <Main
                                onLoad={(content) => {
                                  //  setCurrent(content);
                                }}
                                id={parseInt(route.match.params.id)}
                                getMainConfig={getMainConfig}
                                getListConfig={getListConfig}
                                redirect={(url: string) => {
                                  navigate(url);
                                  //  commonAfterAction(route.history, 0, [url])
                                }}
                              />
                            )}
                          />
                          {/* <MainRoute config={Config} /> */}
                          <footer>
                            Powered by{" "}
                            <a href="http://www.digimaker.org" target="_blank">
                              <img
                                src={process.env.PUBLIC_URL + "/logo.png"}
                                height="18px"
                              />
                              &nbsp;Digimaker CMF
                            </a>
                          </footer>
                        </div>
                      </Content>
                    </Layout>
                  </Layout>
                )}
              </DMInit>
            </div>
          </Route>
        </Switch>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
